import { gql } from "@apollo/client"

const DELETE_EVENT_MUTATION = gql`
  mutation($input: DeleteEventInput!) {
    deleteEvent(input: $input) {
      id
      success
    }
  }
`

export default DELETE_EVENT_MUTATION